import { render, staticRenderFns } from "./AddEditProductToCertificate.vue?vue&type=template&id=4a8563c0&scoped=true"
import script from "./AddEditProductToCertificate.vue?vue&type=script&lang=js"
export * from "./AddEditProductToCertificate.vue?vue&type=script&lang=js"
import style0 from "./AddEditProductToCertificate.vue?vue&type=style&index=0&id=4a8563c0&prod&lang=scss"
import style1 from "./AddEditProductToCertificate.scss?vue&type=style&index=1&id=4a8563c0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8563c0",
  null
  
)

export default component.exports